import React from "react";
import { Img } from "../../../Img";
export const IconAndTitleCard = (props) => (React.createElement("a", { href: props.cardUrl, className: "icon-and-title-card" },
    React.createElement(Img, { className: "icon-and-title-card__image", src: props.iconURL, alt: props.iconAlt }),
    React.createElement("p", null, props.title)));
